<template>
    <div>
        <div class="bax-collapse">
            <div class="bax-collapse-header d-md-flex align-items-center">
                <strong>{{ drug.drug1_name }}</strong>
                <span class="ml-auto d-block mt-3 mt-md-0" @click="toggle">
                    {{ open === true ? 'Hide Details' : 'View Details' }}<i class="icon-chevron-up"></i>
                </span>
            </div>
        </div>
        <div class="bax-order-summary" v-if="open === true">
            <ul>
                <li class="d-md-flex">
                    <span>Qty: </span>
                    <strong class="ml-auto text-md-right">{{ drug.quantity }}</strong>
                </li>
                <li class="d-md-flex">
                    <span>Dose: </span>
                    <strong class="ml-auto text-md-right">{{ drug.drug1Dose }}{{drug.drug1_maxdose_uom}}</strong>
                </li>
                <li class="d-md-flex">
                    <span>Route: </span>
                    <strong class="ml-auto text-md-right">{{ drug.admin_route_desc }}</strong>
                </li>
                <li class="d-md-flex">
                    <span>Container & Fluid: </span>
                    <strong class="ml-auto text-md-right">{{ drug.container_type_name }}</strong>
                </li>
                <li class="d-md-flex">
                    <span>{{drug.diluentExactFinalVolume ? "Exact Final Vol:" : "Container Vol:" }}</span>
                    <strong class="ml-auto text-md-right">{{ drug.diluentVolume }}ml</strong>
                </li>
                <li class="d-md-flex">
                    <span>Date time required: </span>
                    <strong class="ml-auto text-md-right d-md-flex">{{ drug.treatmentDate ? drug.treatmentDate : '--' }}
                        <span>{{ drug.infusionTime ? drug.infusionTime : '--' }}</span></strong>
                </li>
                <li class="d-md-flex">
                    <span>Ancillary: </span>
                    <strong class="ml-auto text-md-right">--</strong>
                </li>
            </ul>
            <div class="bax-order-action-item">
                <ul class="d-md-flex justify-content-end">
                    <li>
                        <a href="#" @click.prevent="$emit('removeDrug')" class="bax-btn bax-btn-bordered bax-btn-bordered-white">
                            <i class="icon-delete"></i>Remove
                        </a>
                    </li>
                    <li>
                        <a href="javascript:;" class="bax-btn bax-btn-white">
                            <i class="icon-edit"></i>Edit
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <br v-if="open === true" />
    </div>
</template>

<script>
export default {
    name: 'PatientSummaryDrugInfo',
    props: ['drug'],
    data() {
        return {
            open: false,
        };
    },
    methods: {
        toggle() {
            if (this.open === true) {
                this.open = false;
            } else {
                this.open = true;
            }
        },
    },
};
</script>
